(function () {
  'use strict';

  var body = document.body;
  var mobileQuery = window.matchMedia('(max-width: 940px)');
  var activeOverlayCount = 0;

  function setPageLock(locked) {
    activeOverlayCount = Math.max(0, activeOverlayCount + (locked ? 1 : -1));
    body.classList.toggle('is-locked', activeOverlayCount > 0);
  }

  function initHeader() {
    var header = document.querySelector('[data-al-header]');
    if (!header) return;

    var menuButton = header.querySelector('[data-al-menu]');
    var menuClose = header.querySelector('[data-al-menu-close]');
    var nav = header.querySelector('[data-al-nav]');
    var backdrop = header.querySelector('[data-al-backdrop]');
    var megaItems = Array.prototype.slice.call(header.querySelectorAll('[data-al-mega-item]'));
    var closeTimer;

    function closeMegas(except) {
      megaItems.forEach(function (item) {
        if (item === except) return;
        item.classList.remove('is-open');
        var link = item.querySelector('.al-nav-link');
        if (link) link.setAttribute('aria-expanded', 'false');
      });
    }

    function openMega(item) {
      closeMegas(item);
      item.classList.add('is-open');
      var link = item.querySelector('.al-nav-link');
      if (link) link.setAttribute('aria-expanded', 'true');
    }

    function closeMega(item) {
      item.classList.remove('is-open');
      var link = item.querySelector('.al-nav-link');
      if (link) link.setAttribute('aria-expanded', 'false');
    }

    function openMenu() {
      if (!nav || nav.classList.contains('is-open')) return;
      nav.classList.add('is-open');
      if (menuButton) menuButton.setAttribute('aria-expanded', 'true');
      if (backdrop) backdrop.hidden = false;
      setPageLock(true);
    }

    function closeMenu() {
      if (!nav || !nav.classList.contains('is-open')) return;
      nav.classList.remove('is-open');
      if (menuButton) menuButton.setAttribute('aria-expanded', 'false');
      if (backdrop) backdrop.hidden = true;
      closeMegas();
      setPageLock(false);
    }

    if (menuButton) menuButton.addEventListener('click', openMenu);
    if (menuClose) menuClose.addEventListener('click', closeMenu);
    if (backdrop) backdrop.addEventListener('click', closeMenu);

    megaItems.forEach(function (item) {
      var link = item.querySelector('.al-nav-link');
      var mega = item.querySelector('[data-al-mega]');
      if (!link || !mega) return;

      item.addEventListener('mouseenter', function () {
        if (!mobileQuery.matches) {
          window.clearTimeout(closeTimer);
          openMega(item);
        }
      });
      item.addEventListener('mouseleave', function () {
        if (!mobileQuery.matches) {
          closeTimer = window.setTimeout(function () { closeMega(item); }, 110);
        }
      });
      item.addEventListener('focusin', function () {
        if (!mobileQuery.matches) openMega(item);
      });
      item.addEventListener('focusout', function (event) {
        if (!mobileQuery.matches && !item.contains(event.relatedTarget)) closeMega(item);
      });
      link.addEventListener('click', function (event) {
        if (!mobileQuery.matches) return;
        if (!item.classList.contains('is-open')) {
          event.preventDefault();
          openMega(item);
        }
      });
    });

    var searchOpen = header.querySelector('[data-al-search-open]');
    var searchClose = header.querySelector('[data-al-search-close]');
    var searchOverlay = header.querySelector('[data-al-search-overlay]');
    var searchField = header.querySelector('[data-al-search-field]');
    var searchWasOpen = false;

    function toggleSearch(show) {
      if (!searchOverlay || show === searchWasOpen) return;
      searchWasOpen = show;
      searchOverlay.hidden = !show;
      setPageLock(show);
      if (show && searchField) window.setTimeout(function () { searchField.focus(); }, 30);
      if (!show && searchOpen) searchOpen.focus();
    }

    if (searchOpen) searchOpen.addEventListener('click', function () { toggleSearch(true); });
    if (searchClose) searchClose.addEventListener('click', function () { toggleSearch(false); });

    document.addEventListener('click', function (event) {
      if (!mobileQuery.matches && !event.target.closest('[data-al-header]')) closeMegas();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (searchWasOpen) toggleSearch(false);
      closeMenu();
      closeMegas();
    });
    mobileQuery.addEventListener('change', function () {
      closeMenu();
      closeMegas();
    });
  }

  function initSliders() {
    document.querySelectorAll('[data-al-slider]').forEach(function (slider) {
      var slides = Array.prototype.slice.call(slider.querySelectorAll('[data-al-slide]'));
      var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-al-slider-dot]'));
      var previous = slider.querySelector('[data-al-slider-prev]');
      var next = slider.querySelector('[data-al-slider-next]');
      var index = 0;
      var timer;
      var delay = parseInt(slider.getAttribute('data-delay') || '5500', 10);
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function show(nextIndex) {
        if (!slides.length) return;
        index = (nextIndex + slides.length) % slides.length;
        slides.forEach(function (slide, slideIndex) {
          var active = slideIndex === index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      function stop() {
        if (timer) window.clearInterval(timer);
        timer = null;
      }

      function start() {
        stop();
        if (!reducedMotion && slides.length > 1 && !document.hidden) {
          timer = window.setInterval(function () { show(index + 1); }, delay);
        }
      }

      if (previous) previous.addEventListener('click', function () { show(index - 1); start(); });
      if (next) next.addEventListener('click', function () { show(index + 1); start(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          show(parseInt(dot.getAttribute('data-al-slider-dot'), 10));
          start();
        });
      });
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', function () { document.hidden ? stop() : start(); });
      show(0);
      start();
    });
  }

  function initProductTabs() {
    document.querySelectorAll('[data-al-product-tabs]').forEach(function (section) {
      var tabs = Array.prototype.slice.call(section.querySelectorAll('[data-al-product-tab]'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('[data-al-product-panel]'));

      function activateTab(tab, moveFocus) {
        var key = tab.getAttribute('data-al-product-tab');
        tabs.forEach(function (item) {
          var active = item === tab;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.setAttribute('tabindex', active ? '0' : '-1');
        });
        panels.forEach(function (panel) {
          var active = panel.getAttribute('data-al-product-panel') === key;
          panel.hidden = !active;
          panel.classList.toggle('is-active', active);
        });
        if (moveFocus) tab.focus();
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          activateTab(tab, false);
        });
        tab.addEventListener('keydown', function (event) {
          var current = tabs.indexOf(tab);
          var nextIndex = current;
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') nextIndex = (current + 1) % tabs.length;
          else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') nextIndex = (current - 1 + tabs.length) % tabs.length;
          else if (event.key === 'Home') nextIndex = 0;
          else if (event.key === 'End') nextIndex = tabs.length - 1;
          else return;
          event.preventDefault();
          activateTab(tabs[nextIndex], true);
        });
      });
    });

    document.querySelectorAll('.al-rail-wrap').forEach(function (wrap) {
      var rail = wrap.querySelector('[data-al-rail]');
      var previous = wrap.querySelector('[data-al-rail-prev]');
      var next = wrap.querySelector('[data-al-rail-next]');
      if (!rail) return;
      function distance() { return Math.max(rail.clientWidth * .82, 260); }
      if (previous) previous.addEventListener('click', function () { rail.scrollBy({ left: -distance(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: distance(), behavior: 'smooth' }); });
    });
  }

  function initCollectionTree() {
    var container = document.querySelector('[data-al-collection-tree]');
    if (!container) return;

    var list = container.querySelector('[data-al-collection-tree-list]');
    var status = container.querySelector('[data-al-collection-tree-status]');
    var parentSlot = container.querySelector('[data-al-collection-tree-parent]');
    var fallbackNode = container.querySelector('[data-al-collection-tree-fallback]');
    var currentCode = (container.getAttribute('data-current-code') || '').toUpperCase();
    var currentHandle = container.getAttribute('data-current-handle') || '';
    var currentTitle = container.getAttribute('data-current-title') || '';
    var codePattern = /^((?:1[A-Z])(?:2[A-Z])?(?:3[A-Z])?(?:4[A-Z])?)\s*-\s*(.+)$/i;
    var shopRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    var cacheKey = 'animalook-collection-tree-v3';
    var cacheLifetime = 15 * 60 * 1000;

    if (!list || !status || !currentCode) return;
    if (shopRoot.charAt(shopRoot.length - 1) !== '/') shopRoot += '/';

    function collectionUrl(handle) {
      return shopRoot + 'collections/' + encodeURIComponent(handle);
    }

    function compareNodes(a, b) {
      if (a.code < b.code) return -1;
      if (a.code > b.code) return 1;
      return a.label.localeCompare(b.label, 'fr');
    }

    function normalise(entries) {
      var byCode = Object.create(null);

      (entries || []).forEach(function (entry) {
        var code;
        var handle;
        var label;
        var count = null;

        if (Array.isArray(entry)) {
          code = String(entry[0] || '').toUpperCase();
          handle = String(entry[1] || '');
          label = String(entry[2] || '');
        } else {
          var match = String(entry.title || '').match(codePattern);
          if (!match) return;
          code = match[1].toUpperCase();
          handle = String(entry.handle || '');
          label = match[2].trim();
          if (Object.prototype.hasOwnProperty.call(entry, 'products_count')) {
            count = Number(entry.products_count);
            if (!isFinite(count)) count = null;
          }
        }

        if (!code || !handle || !label) return;

        var candidate = {
          code: code,
          handle: handle,
          label: label,
          count: count,
          level: code.length / 2
        };
        var existing = byCode[code];
        var candidateIsCurrent = code === currentCode && handle === currentHandle;
        var existingIsCurrent = existing && existing.code === currentCode && existing.handle === currentHandle;
        var candidateScore = candidateIsCurrent ? Number.MAX_SAFE_INTEGER : (count === null ? -1 : count);
        var existingScore = existingIsCurrent ? Number.MAX_SAFE_INTEGER : (!existing || existing.count === null ? -1 : existing.count);

        if (!existing || candidateScore >= existingScore) byCode[code] = candidate;
      });

      byCode[currentCode] = {
        code: currentCode,
        handle: currentHandle,
        label: currentTitle,
        count: null,
        level: currentCode.length / 2
      };

      return byCode;
    }

    function renderParent(byCode) {
      if (!parentSlot) return;
      parentSlot.innerHTML = '';
      if (currentCode.length <= 2) return;

      var parentCode = currentCode.slice(0, -2);
      while (parentCode.length >= 2 && !byCode[parentCode]) parentCode = parentCode.slice(0, -2);
      if (!byCode[parentCode]) return;

      var link = document.createElement('a');
      link.className = 'al-category-tree__back';
      link.href = collectionUrl(byCode[parentCode].handle);
      link.textContent = '← Retour à ' + byCode[parentCode].label;
      parentSlot.appendChild(link);
    }

    function buildBranch(byCode) {
      var childrenByCode = Object.create(null);
      var descendants = Object.keys(byCode).map(function (code) {
        return byCode[code];
      }).filter(function (node) {
        return node.code !== currentCode && node.code.indexOf(currentCode) === 0;
      });

      descendants.forEach(function (node) {
        var parentCode = node.code.slice(0, -2);
        while (parentCode.length > currentCode.length && !byCode[parentCode]) parentCode = parentCode.slice(0, -2);
        if (parentCode.length < currentCode.length || parentCode.indexOf(currentCode) !== 0) parentCode = currentCode;
        if (!childrenByCode[parentCode]) childrenByCode[parentCode] = [];
        childrenByCode[parentCode].push(node);
      });

      Object.keys(childrenByCode).forEach(function (code) {
        childrenByCode[code].sort(compareNodes);
      });

      function prepare(node) {
        var children = (childrenByCode[node.code] || []).map(prepare).filter(Boolean);
        node.children = children;
        if (node.count === 0 && children.length === 0) return null;
        return node;
      }

      return (childrenByCode[currentCode] || []).map(prepare).filter(Boolean);
    }

    function createTreeItem(node, depth, rootCount) {
      var item = document.createElement('li');
      var row = document.createElement('div');
      var link = document.createElement('a');
      var children = node.children || [];

      item.className = 'al-category-tree__item al-category-tree__item--level-' + node.level;
      row.className = 'al-category-tree__row';
      link.className = 'al-category-tree__link';
      link.href = collectionUrl(node.handle);
      link.textContent = node.label;
      row.appendChild(link);
      item.appendChild(row);

      if (children.length) {
        var toggle = document.createElement('button');
        var childList = document.createElement('ul');
        var expanded = depth === 0 && rootCount <= 3;

        toggle.type = 'button';
        toggle.className = 'al-category-tree__toggle';
        toggle.textContent = '›';
        toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        toggle.setAttribute('aria-label', (expanded ? 'Masquer' : 'Afficher') + ' les sous-catégories de ' + node.label);
        childList.className = 'al-category-tree__children';
        childList.hidden = !expanded;

        children.forEach(function (child) {
          childList.appendChild(createTreeItem(child, depth + 1, rootCount));
        });

        toggle.addEventListener('click', function () {
          var show = toggle.getAttribute('aria-expanded') !== 'true';
          toggle.setAttribute('aria-expanded', show ? 'true' : 'false');
          toggle.setAttribute('aria-label', (show ? 'Masquer' : 'Afficher') + ' les sous-catégories de ' + node.label);
          childList.hidden = !show;
        });

        row.appendChild(toggle);
        item.appendChild(childList);
      }

      return item;
    }

    function render(entries) {
      var byCode = normalise(entries);
      var roots = buildBranch(byCode);

      renderParent(byCode);
      list.innerHTML = '';

      if (!roots.length) {
        list.hidden = true;
        status.hidden = false;
        status.textContent = 'Aucune sous-catégorie supplémentaire.';
        return;
      }

      roots.forEach(function (node) {
        list.appendChild(createTreeItem(node, 0, roots.length));
      });
      status.hidden = true;
      list.hidden = false;
    }

    function readFallback() {
      if (!fallbackNode) return [];
      try {
        var data = JSON.parse(fallbackNode.textContent || '[]');
        return Array.isArray(data) ? data : [];
      } catch (error) {
        return [];
      }
    }

    function readCache() {
      try {
        var cached = JSON.parse(window.sessionStorage.getItem(cacheKey) || 'null');
        if (cached && Array.isArray(cached.items) && Date.now() - cached.savedAt < cacheLifetime) return cached.items;
      } catch (error) {}
      return null;
    }

    function writeCache(items) {
      try {
        window.sessionStorage.setItem(cacheKey, JSON.stringify({ savedAt: Date.now(), items: items }));
      } catch (error) {}
    }

    function fetchPage(page, collected) {
      return window.fetch(shopRoot + 'collections.json?limit=250&page=' + page, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        var contentType = response.headers.get('content-type') || '';
        if (!response.ok || contentType.indexOf('application/json') === -1) throw new Error('Collection index unavailable');
        return response.json();
      }).then(function (payload) {
        var pageItems = payload && Array.isArray(payload.collections) ? payload.collections : [];
        pageItems.forEach(function (entry) {
          collected.push({
            title: entry.title,
            handle: entry.handle,
            products_count: entry.products_count
          });
        });
        if (pageItems.length === 250 && page < 10) return fetchPage(page + 1, collected);
        return collected;
      });
    }

    function loadLiveCollections() {
      var cached = readCache();
      if (cached) return Promise.resolve(cached);
      return fetchPage(1, []).then(function (items) {
        if (items.length) writeCache(items);
        return items;
      });
    }

    function entryCode(entry) {
      if (Array.isArray(entry)) return String(entry[0] || '').toUpperCase();
      var match = String(entry && entry.title || '').match(codePattern);
      return match ? match[1].toUpperCase() : '';
    }

    function entryHandle(entry) {
      return Array.isArray(entry) ? String(entry[1] || '') : String(entry && entry.handle || '');
    }

    function collectionHasAvailableProduct(handle, page) {
      page = page || 1;
      return window.fetch(collectionUrl(handle) + '/products.json?limit=250&page=' + page, {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        var contentType = response.headers.get('content-type') || '';
        if (!response.ok || contentType.indexOf('application/json') === -1) throw new Error('Collection products unavailable');
        return response.json();
      }).then(function (payload) {
        var products = payload && Array.isArray(payload.products) ? payload.products : [];
        var available = products.some(function (product) {
          return Array.isArray(product.variants) && product.variants.some(function (variant) {
            return variant.available === true;
          });
        });
        if (available) return true;
        if (products.length === 250 && page < 10) return collectionHasAvailableProduct(handle, page + 1);
        return false;
      }).catch(function () {
        return true;
      });
    }

    function keepAvailableBranches(items) {
      var branchRoots = (items || []).filter(function (entry) {
        var code = entryCode(entry);
        return code.length === currentCode.length + 2 && code.indexOf(currentCode) === 0;
      });

      if (!branchRoots.length) return Promise.resolve(items);

      return Promise.all(branchRoots.map(function (entry) {
        return collectionHasAvailableProduct(entryHandle(entry), 1).then(function (available) {
          return { code: entryCode(entry), available: available };
        });
      })).then(function (states) {
        var unavailableCodes = states.filter(function (state) {
          return !state.available;
        }).map(function (state) {
          return state.code;
        });

        if (!unavailableCodes.length) return items;

        return items.filter(function (entry) {
          var code = entryCode(entry);
          return !unavailableCodes.some(function (unavailableCode) {
            return code.indexOf(unavailableCode) === 0;
          });
        });
      });
    }

    list.hidden = true;
    status.hidden = false;
    status.textContent = 'Chargement des catégories disponibles…';

    if (!window.fetch || !window.Promise) {
      status.textContent = 'Navigation des catégories momentanément indisponible.';
      return;
    }

    loadLiveCollections().then(function (items) {
      return keepAvailableBranches(items);
    }).then(function (items) {
      if (items.length) render(items);
      else {
        list.hidden = true;
        status.hidden = false;
        status.textContent = 'Aucune sous-catégorie disponible.';
      }
    }).catch(function () {
      list.hidden = true;
      status.hidden = false;
      status.textContent = 'Navigation des catégories momentanément indisponible.';
    });
  }

  function initFiltersAndSort() {
    var panel = document.querySelector('[data-al-filter-panel]');
    var backdrop = document.querySelector('.al-filter-backdrop');
    var triggers = Array.prototype.slice.call(document.querySelectorAll('[data-al-filter-open]'));
    var closers = Array.prototype.slice.call(document.querySelectorAll('[data-al-filter-close]'));
    var filterOpen = false;

    function toggleFilters(show) {
      if (!panel || show === filterOpen) return;
      filterOpen = show;
      panel.classList.toggle('is-open', show);
      if (backdrop) backdrop.hidden = !show;
      triggers.forEach(function (button) { button.setAttribute('aria-expanded', show ? 'true' : 'false'); });
      setPageLock(show);
      if (show) {
        var firstControl = panel.querySelector('summary, input, button');
        if (firstControl) window.setTimeout(function () { firstControl.focus(); }, 30);
      }
    }

    triggers.forEach(function (button) { button.addEventListener('click', function () { toggleFilters(true); }); });
    closers.forEach(function (button) { button.addEventListener('click', function () { toggleFilters(false); }); });
    document.addEventListener('keydown', function (event) { if (event.key === 'Escape') toggleFilters(false); });
    mobileQuery.addEventListener('change', function () { if (!mobileQuery.matches) toggleFilters(false); });
    document.querySelectorAll('[data-al-auto-submit]').forEach(function (select) {
      select.addEventListener('change', function () { if (select.form) select.form.submit(); });
    });
  }

  function initProductPage() {
    var mainImage = document.querySelector('[data-al-main-image]');
    document.querySelectorAll('[data-al-thumb]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!mainImage) return;
        mainImage.src = button.getAttribute('data-src');
        mainImage.removeAttribute('srcset');
        document.querySelectorAll('[data-al-thumb]').forEach(function (thumb) { thumb.classList.remove('is-active'); });
        button.classList.add('is-active');
      });
    });

    var variantControl = document.querySelector('[data-al-variant]');
    var price = document.querySelector('[data-al-price]');
    var compare = document.querySelector('[data-al-compare]');
    var buy = document.querySelector('[data-al-buy]');
    var pickup = document.querySelector('[data-al-pickup]');
    var availability = document.querySelector('[data-al-availability]');

    var pickupRequestSequence = 0;

    function renderPickup(id) {
      if (!pickup || !id) return;
      var requestSequence = ++pickupRequestSequence;
      var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';

      pickup.setAttribute('aria-busy', 'true');
      pickup.innerHTML = '<div class="al-pickup-row"><span>Vérification du stock en boutique…</span></div>';

      fetch(root + 'variants/' + encodeURIComponent(id) + '/?section_id=al-pickup-availability', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Pickup availability request failed');
          return response.text();
        })
        .then(function (html) {
          if (requestSequence !== pickupRequestSequence) return;
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          var result = wrapper.querySelector('[data-al-pickup-response]');
          if (!result) throw new Error('Pickup availability response missing');
          pickup.innerHTML = result.innerHTML;
          pickup.removeAttribute('aria-busy');
        })
        .catch(function () {
          if (requestSequence !== pickupRequestSequence) return;
          pickup.innerHTML = '<div class="al-pickup-row"><span>Montebello Mall</span><strong class="al-pickup-status al-pickup-status--no">Disponibilité à confirmer</strong></div><div class="al-pickup-row"><span>Grand Baie La Croisette</span><strong class="al-pickup-status al-pickup-status--no">Disponibilité à confirmer</strong></div>';
          pickup.removeAttribute('aria-busy');
        });
    }

    function syncVariant() {
      if (!variantControl) return;
      var isSelect = variantControl.tagName === 'SELECT';
      var option = isSelect ? variantControl.options[variantControl.selectedIndex] : variantControl;
      var id = option.value;
      var available = isSelect ? option.getAttribute('data-available') === 'true' : !buy || !buy.disabled;
      var selectedPrice = isSelect ? option.getAttribute('data-price') : null;
      var selectedCompare = isSelect ? option.getAttribute('data-compare') : null;
      if (price && selectedPrice) price.textContent = selectedPrice;
      if (compare && isSelect) {
        compare.hidden = !selectedCompare;
        compare.textContent = selectedCompare || '';
        compare.parentElement.classList.toggle('is-sale', Boolean(selectedCompare));
      }
      if (buy) {
        buy.disabled = !available;
        buy.textContent = available ? 'Ajouter au panier' : 'Indisponible';
      }
      if (availability) {
        availability.classList.toggle('is-available', available);
        availability.innerHTML = available ? '<i></i> Disponible à la commande' : 'Actuellement indisponible';
      }
      renderPickup(id);
    }

    if (variantControl) {
      variantControl.addEventListener('change', syncVariant);
      syncVariant();
    }
  }

  function initHomeSharing() {
    var root = document.querySelector('[data-al-home-share]');
    if (!root) return;

    var shareUrl = root.getAttribute('data-share-url') || (window.location.origin + '/pages/nos-liens');
    var modal = root.querySelector('[data-al-share-modal]');
    var dialog = modal ? modal.querySelector('.al-share-modal__dialog') : null;
    var toast = root.querySelector('[data-al-share-toast]');
    var lastTrigger = null;
    var toastTimer = null;
    var modalOpen = false;

    function announce(message) {
      if (!toast) return;
      window.clearTimeout(toastTimer);
      toast.textContent = message;
      toast.classList.add('is-visible');
      toastTimer = window.setTimeout(function () {
        toast.classList.remove('is-visible');
      }, 2400);
    }

    function copyLink() {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(shareUrl).then(function () {
          announce('Lien Animalook copié');
        });
      }

      var field = document.createElement('textarea');
      field.value = shareUrl;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      var copied = document.execCommand('copy');
      document.body.removeChild(field);
      if (copied) announce('Lien Animalook copié');
      else announce('Copie indisponible');
      return Promise.resolve();
    }

    function shareLinks() {
      var shareData = {
        title: 'Animalook Maurice',
        text: 'Retrouvez le site et tous les réseaux sociaux d’Animalook Maurice.',
        url: shareUrl
      };

      if (navigator.share) {
        navigator.share(shareData).catch(function (error) {
          if (!error || error.name !== 'AbortError') announce('Partage indisponible');
        });
        return;
      }

      copyLink();
    }

    function openModal(trigger) {
      if (!modal || modalOpen) return;
      lastTrigger = trigger || document.activeElement;
      modal.hidden = false;
      modalOpen = true;
      setPageLock(true);
      window.setTimeout(function () {
        if (dialog) dialog.focus();
      }, 20);
    }

    function closeModal() {
      if (!modal || !modalOpen) return;
      modal.hidden = true;
      modalOpen = false;
      setPageLock(false);
      if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
    }

    root.querySelectorAll('[data-al-share-trigger]').forEach(function (button) {
      button.addEventListener('click', shareLinks);
    });

    root.querySelectorAll('[data-al-qr-open]').forEach(function (button) {
      button.addEventListener('click', function () {
        openModal(button);
      });
    });

    root.querySelectorAll('[data-al-share-close]').forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    root.querySelectorAll('[data-al-copy-link]').forEach(function (button) {
      button.addEventListener('click', copyLink);
    });

    document.addEventListener('keydown', function (event) {
      if (!modalOpen) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeModal();
        return;
      }
      if (event.key !== 'Tab' || !dialog) return;
      var focusable = Array.prototype.slice.call(dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'));
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  }

  function init() {
    initHeader();
    initSliders();
    initProductTabs();
    initCollectionTree();
    initFiltersAndSort();
    initProductPage();
    initHomeSharing();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
